import * as sonbp from "sonbp";
import * as ifbase from "../base";
import { drawCommon } from "./drawCommon"

/**
* ポスカ用セレクター
* @summary 描画オブジェクトの選択操作を行います。
*/
export class poscaSelector extends sonbp.listener.selector {

	protected _ifdto: ifbase.ifDto;


	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super();

		this._ifdto = ifdto;
	}

	// -----------------------
	// イベント受付機能 関数
	// -----------------------

	/**
	 * マウスダウン処理
	 * @override
	 */
	protected gevMousedown(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {

		let result = super.gevMousedown(e, vp);
		this._state.isMeasuring = false;		//←ドラッグによる範囲選択をさせない

		//console.debug("gevMousedown", this._nextObject);

		return result;
	}

	/**
	 * マウスアップ処理
	 * @override
	 */
	protected gevMouseup(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {

		if (e.which != sonbp.constant.clickWhitch.LEFT && !(this.selectableRightClick && e.which == sonbp.constant.clickWhitch.RIGHT)) return new sonbp.type.listerResult();

		if (this._state.isMeasuring && this._state.ept != null &&
			this._state.spt.viewPt.x != this._state.ept.viewPt.x && this._state.spt.viewPt.y != this._state.ept.viewPt.y) {

			// アイテム矩形選択は不可
			//console.debug("gevMouseup case1.");

			this.measurOff();
		}
		else {

			// クリック選択
			this.measurOff();

			let nextObject = this.getHitObject(vp.docPt);

			if (nextObject == null && this._nextObject == null) {
				// 未選択状態
				//console.debug("gevMouseup case2.");


				if (this._ifdto.client == "PC"
				&& this._ifdto.procMode == ifbase.constants.MODE_PHOTO_MANI)
					// PCモード＆画像編集モードの場合は、選択解除
					this.setSelectInit();
				else if (this._ifdto.client == "SP"
				&& this._ifdto.procMode == ifbase.constants.MODE_PHOTO_REGIST)
					// SPモード＆画像読込・配置モードの場合は、選択解除
					this.setSelectInit();
			}
			else if (nextObject && this._nextObject) {
				if (nextObject.item && this._nextObject.item && nextObject.item.id == this._nextObject.item.id) {
					// 同一のアイテム選択状態
					//console.debug("gevMouseup case3.");

					this.setSelectItems([nextObject.item], true);
				}
				else if (nextObject.snap && this._nextObject.snap && nextObject.snap.line._id == this._nextObject.snap.line._id) {
					// 同一のスナップライン選択状態
					//console.debug("gevMouseup case4.");

					this.setSelectSnapLines(nextObject.snap);
				}
				else if (nextObject.area && this._nextObject.area && nextObject.area.area._id == this._nextObject.area.area._id) {
					// 同一のエリア選択状態
					//console.debug("gevMouseup case5.");

					this.setSelectArea(nextObject.area);
				}
			}
			else {
				//console.debug("gevMouseup case6.");

			}
		}

		var result = new sonbp.type.listerResult();
		result.isDrawEditCanvas = true;
		return result;
	}

	// -----------------------
	// 描画機能 関数
	// -----------------------

	/**
	 * eidtCanvasへの描画
	 * @override
	 */
	protected gdrawEditCanvas(co: sonbp.draw.editCanvasOperator): void {

		// 選択候補描画

		let that = this;
		for (let f = 0; f < this._selectFields.length; f++) {

			let fd = this._selectFields[f];

			//TODO 少しでも処理コスト下げるためgetItems使わない形に。groupがネストするテンプレートあるならgetItemsに戻す必要あり。
			//var items = ifbase.util.getItems(fd.items, function (item: sonbp.object.baseItem): boolean {
			//	return that.poscaCheck(item);
			//});
			let items = [];
			for (let i = 0; i < fd.items.length; i++) {
				let item = fd.items[i];
				if (item.type == "group") {
					if (that.poscaCheck(item, true)) {
						items.push(item);
					}
				} else {
					if (this._select.items.length > 0 && ifbase.util.chkIsStamp(item) && ifbase.util.chkIsPhotoManiInSP(this._ifdto)) {
						//スタンプの矩形は操作に追随
						continue;
					}
					if (that.poscaCheck(item, true)) {
						items.push(item);
					}
				}
			}

			if (items.length > 0) {

				co.ctx.save();

				drawCommon.drawCandidate(this._ifdto, co.ctx, items);

				co.ctx.restore();
			}

		}

		// 選択中オブジェクト描画

		{
			this.drawEditCanvasOfSelectItem(co);
			this.drawEditCanvasOfSnapLine(co);
			this.drawEditCanvasOfArea(co);
		}
	}

	/**
	 * 選択アイテムの描画
	 * @override
	 */
	protected drawEditCanvasOfSelectItem(co: sonbp.draw.editCanvasOperator): void {

		if (this._select.selectType != sonbp.constant.selectType.ITEM) return;
		if (this._select.items.length == 0) return;

		let item = this._select.items[0];

		if (ifbase.util.chkIsPhotobox(this._select.items[0])) {

			// 画像枠なら外接矩形ではなく、クリップパスで描画する
			co.ctx.save();
			{
				this._v._dm.pageTransform(item._apply_pageIdx, co.ctx);
				drawCommon.drawSelectedBox(this._ifdto, co.ctx, item);
			}
			co.ctx.restore();
		} else {

			co.ctx.save();
			{
				var sgpt = this._select.getPointsOfSummary();
				this._v._dm.pageTransform(item._apply_pageIdx, co.ctx);
				drawCommon.drawRect(this._ifdto, co.ctx, sgpt.parts[0]);
			}
			co.ctx.restore();
		}
	}

	// -----------------------------------------------
	// Methods（外部アクセス用メソッド）
	// -----------------------------------------------

	/**
	* 選択アイテム情報取得（ポスカ用）
	*/
	public getPoscaItem(): any {

		let results = [];
		let items = this._select.items;

		for (let i = 0; i < items.length; i++) {

			let vp = items[i].info.vendor_property.ffpsc ?? {};
			let resvp = {} as any;

			resvp.id = items[i].id;
			resvp.item_type = vp.item_type;
			resvp.idx = vp.idx ?? undefined;
			resvp.waku_pita = vp.waku_pita ?? undefined;

			switch (vp.item_type) {
				case ifbase.constants.ITYPE_PHOTO_BOX:
					let c = (<sonbp.object.groupItem>items[i]).childs[0];
					resvp.file_id = c.info.vendor_property.ffpsc.file_id;
					break;

				case ifbase.constants.ITYPE_STAMP_IMG:
				case ifbase.constants.ITYPE_MYSTAMP_IMG:
				case ifbase.constants.ITYPE_FONTGENIC_IMG:
					resvp.file_id = vp.file_id;
					break;
			}

			let posi = sonbp.tool.item.getPosition(this._ifdto.bpView, items[i].id);
			resvp.x = posi.x;
			resvp.y = posi.y;
			resvp.w = posi.width;
			resvp.h = posi.height;
			resvp.r = (360 - posi.deg) % 360;	//sonbpは左回転、業務は右回転

			results.push(resvp);
		}

		return (results.length > 0) ? results[0] : null;
	}

	// -----------------------------------------------
	// Methods（内部関数）
	// -----------------------------------------------

	/**
	 * 描画ページ先頭における選択可能フィールドの設定
	 * @override
	 */
	protected setFieldsOfAll(): sonbp.listener.selectField[] {

		var results: sonbp.listener.selectField[] = [];

		if (this._range.range == sonbp.constant.selectRange.LAYER) {

			let page = this._v._om._doc.pages[this._range.pageIdx];
			let layer = page.layers[this._range.layerIdx];

			if (page.info.mode(sonbp.constant.editModeType.OPERATION_NG)) return results;
			if (layer.info.mode(sonbp.constant.editModeType.OPERATION_NG)) return results;

			let address: sonbp.type.itemAddress = { pageIdx: this._range.pageIdx, layerIdx: this._range.layerIdx, parentId: "", parentIdxs: [] };

			results.push({ address: address, items: layer.items });

		} else if (this._range.range == sonbp.constant.selectRange.ITEM) {

			let item = this._range.itemInfo.item;
			if (item.info.mode(sonbp.constant.editModeType.OPERATION_NG)) return results;

			var items = sonbp.util.obj.getChilds(item, [], true, false);

			if (items != null) {
				var address: sonbp.type.itemAddress = this._range.itemInfo.address;
				results.push({ address: address, items: items });
			}

		} else {

			// page,all

			for (var i = 0; i < this._v._dm.pageIdxs.length; i++) {

				var idx = this._v._dm.pageIdxs[i];

				var page = this._v._om._doc.pages[idx];
				if (page.info.mode(sonbp.constant.editModeType.OPERATION_NG)) continue;

				if (this._range.range == sonbp.constant.selectRange.PAGE && this._range.pageIdx != idx) continue;

				//【ここだけポスカ仕様】
				// レイヤーはそのままの順番で登録
				for (var j = 0; j < page.layers.length; j++) {

					var layer = page.layers[j];
					if (layer.info.mode(sonbp.constant.editModeType.OPERATION_NG)) continue;

					var address: sonbp.type.itemAddress = { pageIdx: idx, layerIdx: j, parentId: "", parentIdxs: [] };

					results.push({ address: address, items: layer.items });
				}
			}
		}

		return results;
	}

	/**
	 * 単一アイテムチョイス
	 * @override
	 */
	protected getHitItem(docPt: sonbp.type.point[], isContainsSelectItem: boolean = false): sonbp.object.baseItem {

		if (this._ifdto.client == "PC") {
			if (this._ifdto.procMode == ifbase.constants.MODE_PHOTO_MANI) {
				//PCモード且つ画像編集モードの場合のみ選択解除可能
				return super.getHitItem(docPt, isContainsSelectItem);
			}
		} else {
			//SPモード
			if (this._ifdto.procMode == ifbase.constants.MODE_PHOTO_REGIST) {
				//SPモード且つ画像読込・配置モードの場合のみ選択解除可能
				return super.getHitItem(docPt, isContainsSelectItem);
			}
			else if (ifbase.util.chkIsPhotoManiInSP(this._ifdto)) {
				//SPモード且つ画像操作中は、他アイテムへ選択切換え不可
				return null;
			}
		}

		// 選択対象
		let hits = this.getHitItems(docPt);

		// 候補が存在しない
		// →未選択
		if (hits.lstFldIdx == -1) {
			return null;
		}

		// 選択アイテムが存在しない
		// → そのまま選択

		if (this._select.items.length == 0) {
			return hits.fields[hits.lstFldIdx][hits.lstItmIdx];
		}

		// 選択候補に選択アイテムが存在するかチェック

		let f_f_idx = -1, f_i_idx = -1, l_f_idx = -1, l_i_idx = -1;

		if (!isContainsSelectItem) {

			for (let f = 0; f < hits.fields.length; f++) {
				for (let i = 0; i < hits.fields[f].length; i++) {

					this._select.items.every(sitem => {

						if (sitem.id == hits.fields[f][i].id) {
							l_f_idx = f;
							l_i_idx = i;

							if (f_f_idx == -1) {
								f_f_idx = l_f_idx;
								f_i_idx = l_i_idx;
							}
						}
						return true;
					});
				}
			}
		}

		// 選択アイテムが存在するが、候補には選択アイテムが存在しない
		// → そのまま選択

		if (l_f_idx == -1) {
			return hits.fields[hits.lstFldIdx][hits.lstItmIdx];
		}

		// 選択アイテムが存在し、候補にも選択アイテムが存在する

		// 選択アイテムより優先順の高いフィールドに選択候補がいる
		// →それを選択

		if (l_f_idx < hits.lstFldIdx) {
			return hits.fields[hits.lstFldIdx][hits.lstItmIdx];
		}

		//【ここだけポスカ仕様】
		// 選択アイテムが idx==0 のアイテムで、フィールドのオーナーが不在（layer直下）の場合
		// →優先順最下位の選択候補を選択★
		//  選択アイテムが idx==0のアイテムで、フィールドのオーナーが存在（group直下）の場合
		// →フィールドのオーナーアイテムを選択とする
		// 選択アイテムが idx==0以外のアイテム
		// →--idxのアイテムを選択

		if (l_i_idx == 0) {
			if (hits.owners[l_f_idx] != null) {
				return hits.owners[l_f_idx]
			}
			return hits.fields[l_f_idx][hits.lstItmIdx];
		}
		return hits.fields[l_f_idx][l_i_idx - 1];
	}

	/**
	 * アイテムが現在の処理モードの操作対象であるかを返す
	 * @param item
	 * @param nonSelectOnly
	 */
	protected poscaCheck(item: sonbp.object.baseItem, nonSelectOnly?: boolean): boolean {

		if (nonSelectOnly && this._select.selectType == sonbp.constant.selectType.ITEM) {
			for (let i = 0; i < this._select.items.length; i++) {
				if (item.id == this._select.items[i].id)
					return false;
			}
		}

		let itemType = item.info.vendor_property.ffpsc?.item_type;
		if (!itemType) return false;

		// 画像アイテムと他アイテムの２パターンで処理を分ける
		// 2025年対応：配置済み画像の再編集可能 #28295
		//console.debug(`mode: ${this._ifdto.procMode}, type: ${itemType}`);
		return true;
	}

	/**
	 * 選択可能アイテムの捜索
	 * @override
	 */
	protected fieldsCheck(func: (item: sonbp.object.baseItem, pageIdx: number, diveIdx: number) => boolean): void {

		let formCheck = (item: sonbp.object.baseItem, pageIdx: number, diveIdx: number): boolean => {

			if ('forms' in item) {

				let forms = (item as sonbp.object.IholdEditFormItem).forms;

				for (let k = 0; k < forms.length; k++) {

					let form = forms[k] as sonbp.object.formTopGroupItem;

					if (!form.existObject) continue;

					for (let s = 0; s < form.childs.length; s++) {
						if (func(form.childs[s], pageIdx, diveIdx)) {
							return true;
						}
						if (formCheck(form.childs[s], pageIdx, diveIdx)) {
							return true;
						}
					}
				}
			}

			return false;
		};

		let that = this;
		let itemCheck = (item: sonbp.object.baseItem, pageIdx: number, diveIdx: number): boolean => {

			if (!that.poscaCheck(item)) {
				return false;
			}

			if (func(item, pageIdx, diveIdx)) {
				return true;
			}

			if (formCheck(item, pageIdx, diveIdx)) {
				return true;
			}

			return false;
		};

		for (var f = 0; f < this._selectFields.length; f++) {
			let fd = this._selectFields[f];
			for (var g = 0; g < fd.items.length; g++) {
				if (itemCheck(fd.items[g], fd.address.pageIdx, 0)) return;
			}
		}

		for (let i = 0; i < this._selectDivingField.length; i++) {
			let fd = this._selectDivingField[i];
			for (var g = 0; g < fd.f.items.length; g++) {
				if (itemCheck(fd.f.items[g], fd.f.address.pageIdx, i + 1)) return;
			}
		}
	}

}